
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getNotInDeptUserList, getDeptUserList, batchDelDeptUser } from '@/api/company';
import { setUserDept, setUserRole, getRoleUserList, getNoRoleUserList, batchDelRoleUser, getUserList } from '@/api/users';
import { UserModule } from '../../../store/modules/user';
@Component({
  name: 'SetStaff',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogSetStaffVisible!: Boolean;
  @Prop({
    type: String,
    default: ''
  })
  paramsStr!: String;
  @Prop({
    type: Number,
    default: 0
  })
  typeEnter!: Number;
  @Prop({
    type: Boolean,
    default: false
  })
  radioSelectedStaff?: Boolean;
  @Prop({
    type: Array,
    default: () => {}
  })
  selectUser!: Array<Object>;
  @Prop({
    type: String,
    default: ''
  })
  detpId!: any;

   private title='选择人员';
  // 1 添加部门人员 2 删除部门人员 3 添加角色人员 4 删除角色人员 5 分公司群组选择人员搜索 6 库存预警人员 7班次人员 8 项目负责人 9 项目关联人 10 任务集负责人
  // 11 任务负责人 12 客户选择关联人员 13 项目管理员 14 所有项目查看人员 15 项目创建人员
  private listQuery:any = {
    name: ''
  };
  private listLoading=false;
  private selectedDynamicTags:any=[];
  private selectUserId:any=[];

  private userSelectedAll= false; // 全选中
  private isIndeterminate= false; // 全选框 模糊状态

  created() {
    if (!this.radioSelectedStaff) {
      this.selectedDynamicTags = this.selectUser;
    } else {
      if (this.selectUser && this.selectUser.length > 0) {
        this.selectedDynamicTags = this.selectUser[0];
      }
    }
    this.getList();
  }
  // 列表
  private tableList:any = [];
  private page = 1;
  private loadMore=false;

  cancleDialogHandle() {
    this.$emit('close', false);
  }
  finishDialogHandle() {
    this.conform();
  }
  // 搜索
  private search() {
    this.page = 1;
    this.getList();
  }
  // 搜索清楚
  private restSearch() {
    this.page = 1;
    this.listQuery = {
      name: ''
    };
    this.getList();
  }
  // 加载更多
  private moreData() {
    this.page = this.page + 1;
    this.getList();
  }
  // 获取列表
  private getList() {
    // 人员不再部门内
    let moduleCdes:any = {};
    let arr:any = [];
    switch (this.typeEnter) {
      case 1:
        this.title = '添加人员';
        this.getNotInDeptUserList();
        break;
      case 2:
        this.title = '删除人员';
        this.getDeptUserList();
        break;
      case 3:
        this.title = '添加人员';
        this.getNoRoleUserList();
        break;
      case 4:
        this.title = '删除人员';
        this.getRoleUserList();
        break;
      case 5:
        this.listLoading = true;
        this.title = '选择人员';
        this.getUserList(1, '');
        break;
      case 6:
        this.title = '警告人员设定';
        this.getUserList(0, -'');
        break;
      case 7:
        this.listLoading = true;
        this.title = '选择人员';
        this.getUserList(1, '');
        break;
      case 8:
        this.listLoading = true;
        this.title = '选择项目负责人';
        this.getUserList(-1, '');
        break;
      case 9:
        this.listLoading = true;
        this.title = '选择项目关联人';
        this.getUserList(-1, '');
        break;
      case 10:
        this.listLoading = true;
        this.title = '选择任务集负责人';
        this.getUserList(-1, '');
        break;
      case 11:
        this.listLoading = true;
        this.title = '选择任务负责人';
        this.getUserList(-1, '');
        break;
      case 12:
        this.listLoading = true;
        this.title = '选择关联人员';
        moduleCdes.module_code = 'ls670010';
        arr = [moduleCdes];
        this.getUserList(-1, JSON.stringify(arr));
        break;
      case 13:
        this.listLoading = true;
        this.title = '选择超级管理员';
        this.getUserList(-1, '');
        break;
      case 14:
        this.listLoading = true;
        this.title = '选择查看人员';
        this.getUserList(-1, '');
        break;
      case 15:
        this.listLoading = true;
        this.title = '选择创建人员';
        this.getUserList(-1, '');
        break;
      //选择人员 所有人员 通用  
      case 99:
        this.listLoading = true;
        this.title = '选择人员';
        this.getUserList(-1, '');
        break;
    }
  }
  // 确认 按钮
  private conform() {
    if( !(this.typeEnter==12 || this.typeEnter==14 || this.typeEnter==15) ){
      //判断是不是数组
      if (this.selectedDynamicTags instanceof Array && this.selectedDynamicTags.length < 1) {
        this.showErrorMsg('请选择人员');
        return;
      }else{
        //超管this.selectedDynamicTags不是数组是对象 
        //判断空对象
        if (Object.keys(this.selectedDynamicTags).length === 0) {
          this.showErrorMsg('请选择人员');
          return;
        }
      }
    }
 
    switch (this.typeEnter) {
      case 1:
        this.setDeptUserList(this.selectedDynamicTags);
        break;
      case 2:
        this.delDeptUserList(this.selectedDynamicTags);
        break;
      case 3:
        this.setRoleUserList(this.selectedDynamicTags);
        break;
      case 4:
        this.delRoleUserList(this.selectedDynamicTags);
        break;
      case 5:
      case 99:
        if (this.radioSelectedStaff) {
          this.$emit('searchUser', this.selectedDynamicTags);
          this.$emit('close', false);
        } else {
          this.$emit('selectUser', this.selectedDynamicTags);
          this.$emit('close', false);
        }

        break;
      case 6:
        this.$emit('selectUser', this.selectedDynamicTags);
        break;
      case 7:
        if (this.radioSelectedStaff) {
          this.$emit('selectUser', this.selectedDynamicTags);
          this.$emit('close', false);
        } else {
          this.$emit('selectUser', this.selectedDynamicTags);
          this.$emit('close', false);
        }

        break;
      case 8:
      case 9:
      case 10:
      case 11:
        if (this.radioSelectedStaff) {
          this.$emit('searchUser', this.selectedDynamicTags);
          this.$emit('close', false);
        } else {
          this.$emit('selectUser', this.selectedDynamicTags);
          this.$emit('close', false);
        }
        break;
      case 12:
      case 13:
      case 14:
      case 15:
        if (this.radioSelectedStaff) {
          this.$emit('searchUser', this.selectedDynamicTags);
        } else {
          this.$emit('selectUser', this.selectedDynamicTags);
        }
        break;
    }
  }
  // 添加 部门人员列表
  private getNotInDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNotInDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 部门人员
  private setDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      department_str: this.paramsStr,
      user_str: userStr
    };
    setUserDept(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
  }
  // 删除 部门人员
  private delDeptUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      dept_id: this.paramsStr,
      user_str: userStr
    };
    batchDelDeptUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
  }
  // 删除 部门人员 列表
  private getDeptUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.dept_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getDeptUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 删除 角色人员列表
  private getRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.company_role_id = this.paramsStr;
    params.name = this.listQuery.name;
    params.page = this.page;
    getRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }

  // 添加 部门人员列表
  private getNoRoleUserList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.company_role_id = this.paramsStr;
    params.page = this.page;
    params.name = this.listQuery.name;
    getNoRoleUserList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
        } else {
          this.tableList = [];
        }
      })
      .catch(err => {
        this.tableList = [];
        let msg = err.msg;
      });
  }
  // 添加 角色人员
  private setRoleUserList(roleData:any) {
    let _this = this;
    var userStr = '';
    for (var user of roleData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_role_id: this.paramsStr,
      user_str: userStr,
      vip_level: (UserModule.company as any).vip_level
    };
    setUserRole(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
  }
  // 删除 角色人员
  private delRoleUserList(departmentData:any) {
    let _this = this;
    var userStr = '';
    for (var user of departmentData) {
      userStr += (user as any).uid + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_role_id: this.paramsStr,
      user_str: userStr
    };
    batchDelRoleUser(params)
      .then(res => {
        _this.page = 1;
        _this.$emit('close', false);
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center',
          type: 'success'
        });
      })
      .catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
  }

  // 所有人员接口
  getUserList(isUserList:number, moduleCdes:any) {
    let that = this;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.page
    };
    if (isUserList !== -1) {
      params.is_user_list = isUserList;
    }
    if (moduleCdes) {
      params.module_codes = moduleCdes;
    }
    params.name = this.listQuery.name;
    if (this.detpId) {
      params.department_id = this.detpId;
    }
    getUserList(params)
      .then(res => {
        this.listLoading = false;
        if (res.data) {
          if (this.page === 1) {
            this.tableList = res.data.list;
          } else {
            this.tableList = this.tableList.concat(res.data.list);
          }
          if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
            this.loadMore = true;
          } else {
            this.loadMore = false;
          }
          // 设置选中
          this.$nextTick(function() {
            if (that.selectUser && that.selectUser.length > 0) {
              that.selectUser.forEach((ser:any) => {
                let have:any = [];
                if (that.tableList) {
                  have = that.tableList.filter((v:any) => {
                    if (this.typeEnter === 6) {
                      return v.id === ser.user_id;
                    } else {
                      return v.id === ser.id;
                    }
                  });
                }
                if (that.radioSelectedStaff) {
                  if (have && have.length > 0) {
                    that.selectedDynamicTags = have[0];
                  }
                } else {
                  if (have && have.length > 0) {
                    that.selectUserId.push(have[0].id);
                  }
                }
              });
            }
          });
        } else {
          this.loadMore = false;
          this.tableList = [];
        }
      })
      .catch(err => {
        this.listLoading = false;
        this.tableList = [];
        let msg = err.msg;
      });
  }

  private SelectedAll() {
    if (this.userSelectedAll) {
      // 全选
      for (let i = 0; i < this.tableList.length; i++) {
        let index = this.selectUserId.indexOf(this.tableList[i].id);
        if (index === -1) {
          this.selectUserId.push(this.tableList[i].id);
          if (!this.selectedDynamicTags) {
            this.selectedDynamicTags = [];
          }
          this.selectedDynamicTags.push(this.tableList[i]);
        }
      }
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else {
      // 全不选
      this.selectUserId = [];
      this.selectedDynamicTags = [];
    }
  }
  private userSelection(item:any) {
    let select:any = this.selectUserId.filter((id:any) => {
      return id === item.id;
    });
    if (!this.selectedDynamicTags) {
      this.selectedDynamicTags = [];
      if (select && select.length > 0) {
        this.selectedDynamicTags.push(item);
      }
    } else {
      if (select && select.length > 0) {
        this.selectedDynamicTags.push(item);
      } else {
        for (let i = 0; i < this.selectedDynamicTags.length; i++) {
          if (this.selectedDynamicTags[i].id === item.id) {
            this.selectedDynamicTags.splice(i, 1);
            break;
          }
        }
      }
    }
    if (this.selectUserId.length === this.tableList.length) {
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else if (this.selectUserId.length === 0) {
      this.userSelectedAll = false;
      this.isIndeterminate = false;
    } else {
      this.userSelectedAll = false;
      this.isIndeterminate = true;
    }
  }
  private closeTagHandle(val: any) {
    if (this.radioSelectedStaff) {
      this.selectedDynamicTags = {};
    } else {
      this.selectedDynamicTags.splice(this.selectedDynamicTags.indexOf(val), 1);
      this.selectUserId.splice(this.selectUserId.indexOf(val.id), 1);
      if (this.selectUserId.length === this.tableList.length) {
        this.userSelectedAll = true;
        this.isIndeterminate = false;
      } else if (this.selectUserId.length === 0) {
        this.userSelectedAll = false;
        this.isIndeterminate = false;
      } else {
        this.userSelectedAll = false;
        this.isIndeterminate = true;
      }
    }
  }
  close() {
    this.page = 1;
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
